window.PlummeFixedAssetPostingFollowup = (state: any) => {
  if (state.fixedAssetAutomaticPosting?.status !== 'review_required') return [];
  const { t } = window as any;
  const text = t('home.followup.assetPostingIssue');
  return [{
    id: 'asset-posting', title: t('home.followup.assetPostingTitle'), route: 'eiendeler',
    actionLabel: t('home.followup.assetPostingAction'),
    items: [{ text, tone: 'critical', route: 'eiendeler' }],
  }];
};
